/**
 * Runs the base handler first, then the consumer's, so a consumer handler
 * never replaces the one a primitive relies on, like Base UI's popup opener.
 */
export const composeHandlers =
    <E>(
        baseHandler: ((event: E) => void) | undefined,
        consumerHandler: ((event: E) => void) | undefined,
    ) =>
    (event: E) => {
        baseHandler?.(event);
        consumerHandler?.(event);
    };
